import { initializePreviewDiagnostics } from './app/shared/preview-diagnostics';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { PlanReviewerService } from './app/shared/plan-reviewer.service';
import { TabService } from './app/shared/tab.service';
import { EnvironmentService } from './app/shared/environment.service';
import { PingService } from './app/shared/ping.service';
import { ProgressService } from './app/shared/progress.service';
import { GrpcWrapperService } from './app/shared/grpc-wrapper.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpAuthInterceptor } from './app/shared/http-auth.interceptor';
import { ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { GlobalErrorHandler } from './app/shared/client-logging.service';
import { HttpLogInterceptor } from './app/shared/http-log.interceptor';
import { ChatContextSyncService } from './app/services/chat-context-sync.service';
import { initializeApp } from 'firebase/app';
import { environment } from './generated.environments/environment';
import { AuthScopedCacheService } from './app/shared/auth-scoped-cache.service';

initializePreviewDiagnostics();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    // Firebase configuration - initialize Firebase app
    {
      provide: 'FIREBASE_APP',
      useFactory: () => initializeApp(environment.firebase),
    },
    // Application services
    EnvironmentService,
    PingService,
    ProgressService,
    GrpcWrapperService,
    PlanReviewerService,
    TabService,
    // HTTP interceptor for Firebase auth (Issue #263: Chat)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    },
    // HTTP interceptor for logging errors to backend (Issue #736: Phase 2)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLogInterceptor,
      multi: true,
    },
    // Global Error Handler for logging to backend (Issue #724: GCP Logging)
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    // Initialize chat context sync service (Issue #263: Auto-populate chat context)
    provideAppInitializer(() => {
      inject(ChatContextSyncService);
      inject(AuthScopedCacheService);
    }),
  ],
}).catch(err => console.error(err));
